var addressTypes = [
  { "name": "Workplace", "label": "محل فعالیت", value: 0 },
  { "name": "InvoiceSendingAddress", "label": "ارسال صورتحساب", value: 1 },
  { "name": "ShippingAddress", "label": "ارسال کالا", value: 2 },
  { "name": "WarehouseAddress", "label": "انبار", value: 3 },
  { "name": "HomeAddress", "label": "منزل", value: 4 },
  { "name": "OfficialAddress", "label": "رسمی", value: 5 },
  { "name": "PostalAddress", "label": "پستی", value: 6 },
  { "name": "Other", "label": "سایر", value: 7 },
];

export default addressTypes;